<!--Banner antiguo de pantalla principal, probablemente ya no se use-->
<template>
    <v-row justify="center" class="pa-5 my-5 text-center" v-bind:class="(theme==='light')?'':'primary white--text'" align="center">
        <!--<v-col cols="12" data-aos="zoom-in-up" data-aos-duration="450"  data-aos-delay="300">-->
        <v-col cols="12">
            <v-row justify="center">
                <v-col cols="12" class="mt-5">
                    <h1 class="display-3 font-weight-bold mb-2">{{ title }}</h1> 
                    <p class="headline">{{ content }}</p>
                </v-col>
                <v-col cols="12" class="mb-5">
                    <!--<v-btn :to="to" x-large color="accent" class="black--text font-weight-bold headline">{{ btnText }}</v-btn>-->
                    <!-- <v-dialog v-model="dialog" max-width="700">
                    <template v-slot:activator="{ on }"> -->
                        <v-btn v-on="on" x-large color="accent" to="/registro/organizacion" class="black--text font-weight-bold headline">{{ btnText }}</v-btn>
                    <!-- </template>
                    <select-type-user-card></select-type-user-card>
                    </v-dialog> -->
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>
<script>
import selectTypeUserCard from "@/components/landing/select-type-user-card.vue";
export default{
    data(){
        return {
            dialog: false
        }
    },
    /* 
    PROPIEDADES DEL COMPONENTE
    - theme - dark ( DEFAULT - Fondo primary y texto blanco ) ó light ( Fondo blanco y texto negro )
    - title - Título del banner
    - content - Contenido de la tarjeta
    - btnText - Texto del botón
    - to - Ruta de navegación
    */
    props:{
        theme: { type: String },
        title: { type: String, required:true },
        content: { type: String, required:true },
        btnText: { type: String, required:true },
        to: { type: String, required:true }
    },
    components :{
        selectTypeUserCard
    }
}
</script>